import CompleteProfile from '@/ui/pages/complete-profile';
import ProfileTitlePage from '@/ui/pages/profile-title';
import ChooseTemplate from '@/ui/pages/choosetemplate';

import Links from '@/ui/pages/links';
import AddLinks from '@/ui/pages/add-links';
import Login from '@/ui/pages/Login';
import OTP from '@/ui/pages/OTP';
import PreviewDeploy from '@/ui/pages/preview-deploy';
import LogoutPage from '@/ui/pages/Logout';
import BackendDownPage from '@/ui/pages/BackendDown';

export interface IRoute {
  id?: number;
  path: string;
  name: string;
  component: any;
  userRoles?: string[];
  authenticated?: boolean;
  fallback?: React.ComponentType<any>;
}

const appRoutes: IRoute[] = [
  { id: 1, path: '/', name: 'Home', component: Login },
  {
    id: 2,
    path: '/otp',
    name: 'OTP',
    component: OTP,
  },
  {
    id: 3,
    path: '/profile-title',
    name: 'ProfileTitle',
    component: ProfileTitlePage,
    authenticated: true,
  },
  {
    id: 4,
    path: '/complete-profile',
    name: 'CompleteProfile',
    component: CompleteProfile,
    authenticated: true,
  },
  {
    id: 5,
    path: '/choose-template',
    name: 'ChooseTemplate',
    component: ChooseTemplate,
    authenticated: true,
  },

  {
    id: 6,
    path: '/add-links',
    name: 'AddLinks',
    component: AddLinks,
    authenticated: true,
  },
  {
    id: 7,
    path: '/preview-deploy',
    name: 'PreviewDeploy',
    component: PreviewDeploy,
    authenticated: true,
  },
  {
    id: 8,
    path: '/links',
    name: 'Links',
    component: Links,
    authenticated: true,
  },
  {
    id: 9,
    path: '/logout',
    name: 'Logout',
    component: LogoutPage,
  },
  {
    id: 10,
    path: '/backend-down',
    name: 'BackendDown',
    component: BackendDownPage,
  },
];

export default appRoutes;